import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAdminEmails } from "../../configs/auth";


function Admin() {

  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAdminEmails();
        setAdmins(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData()
  }, []);


  return (
    <div className="container-lg p-0 d-flex flex-column flex-sm-row justify-content-around my-4">

      <div className="d-flex flex-column col-sm-4">

        <Link className="btn btn-home-primary my-2 mx-4" to="/admin/newproduct">Új termék</Link>
        <Link className="btn btn-home-primary my-2 mx-4" to="/admin/newcategory">Kategóriák</Link>
        <Link className="btn btn-home-primary my-2 mx-4" to='/guides'>Útmutatók</Link>
        <Link className="btn btn-home-primary my-2 mx-4" to='/admin/deliverysettings'>Szállítási opciók</Link>

      </div>

      <div className="d-flex flex-column col-sm-4 justify-content-start">

        <Link className="btn btn-home-primary my-2 mx-4" to='/admin/orders'>Rendelések</Link>
        <h6 className="my-2 mx-4">Admin emailek száma: {admins}</h6>

      </div>

    </div>
  );
}

export default Admin;
